import { render, staticRenderFns } from "./EditPropertyForm.vue?vue&type=template&id=727e3254"
import script from "./EditPropertyForm.vue?vue&type=script&lang=js"
export * from "./EditPropertyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports